import '../badge/badge.jsx?type=jsx';
export const inferredObservability = true;
export default class Counter extends HTMLElement {
    static get observedAttributes() {
        return ['count'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        console.debug('???attributeChangedCallback', { name });
        console.debug('???attributeChangedCallback', { oldValue });
        console.debug('???attributeChangedCallback', { newValue });
        function getValue(value) {
            return value.charAt(0) === '{' || value.charAt(0) === '[' ? JSON.parse(value) : !isNaN(value) ? parseInt(value, 10) : value === 'true' || value === 'false' ? value === 'true' ? true : false : value;
        }
        if (newValue !== oldValue) {
            switch (name) {
            case 'count':
                this.count = getValue(newValue);
                break;
            }
            this.update(name, oldValue, newValue);
        }
    }
    update(name, oldValue, newValue) {
        console.debug('Update tracking against....', this.constructor.observedAttributes);
        console.debug('Updating', name);
        console.debug('Swap old', oldValue);
        console.debug('For new', newValue);
        console.debug('this[name]', this[name]);
        const attr = `data-wcc-${ name }`;
        const selector = `[${ attr }]`;
        console.debug({ attr });
        console.debug({ selector });
        this.querySelectorAll(selector).forEach(el => {
            const needle = oldValue || el.getAttribute(attr);
            console.debug({ el });
            console.debug({ needle });
            console.debug({ newValue });
            switch (el.getAttribute('data-wcc-ins')) {
            case 'text':
                el.textContent = el.textContent.replace(needle, newValue);
                break;
            case 'attr':
                if (el.hasAttribute(el.getAttribute(attr))) {
                    el.setAttribute(el.getAttribute(attr), newValue);
                }
                break;
            }
        });
        if (['count'].includes(name)) {
        }
        console.debug('****************************');
    }
    constructor() {
        super();
        this.count = 0;
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const {count} = this;
        this.innerHTML = `<div>
        <button onclick="this.parentElement.parentElement.count-=1; this.parentElement.parentElement.setAttribute(\'count\', this.parentElement.parentElement.count);"> -</button>
        <span>You have clicked <wcc-badge counter="${ count }" data-wcc-count="counter" data-wcc-ins="attr"></wcc-badge> times !!!</span>
        <button onclick="this.parentElement.parentElement.count+=1; this.parentElement.parentElement.setAttribute(\'count\', this.parentElement.parentElement.count);"> +</button>
      </div>`;
    }
}
customElements.define('wcc-counter', Counter);